import React from 'react';
import { Anchor } from 'antd';
import { getWithoutSpaces } from 'common/helpers/format.helper';
import { useAppSelector } from 'app/store/store.hooks';
import { ANCHOR_TOP_OFFSET } from 'entities/Menu/Menu.const';

export const BitecoinRewardCategoriesPanel: React.FC = () => {
  const { bitecoinGroupedRewardCollection } = useAppSelector((state) => state.bitecoin);
  const categories = Array.from(new Map(bitecoinGroupedRewardCollection?.map((r) => [r.category.id, r.category])).values());

  if (!categories?.length) {
    return null;
  }

  const handleAnchorAction = (href: string) => {
    const formattedName = href.replace(/#/g, '');

    if (!formattedName) {
      return;
    }

    const wrapper = document.getElementsByClassName('anchor')[0];

    if (wrapper) {
      const link = wrapper.querySelector(`a[href="#${formattedName}"]`);

      if (link) {
        const leftPadding = 24;
        // Same fix as CategoriesPanel: measure against the centered .ant-anchor box, not the
        // full-bleed wrapper — wrapper-based math dragged the bar left by the desktop
        // centering gap.
        const box = wrapper.querySelector('.ant-anchor') ?? wrapper;
        const leftItemOffset = link.getBoundingClientRect().left - box.getBoundingClientRect().left;

        wrapper.scrollLeft = Math.max(0, leftItemOffset - leftPadding);
      }
    }
  };

  const items = categories.map(({ name, id }) => ({
    key: String(id),
    href: `#${getWithoutSpaces(name)}`,
    title: name,
  }));

  return (
    <div className="store-panel pl-2">
      <Anchor
        targetOffset={ANCHOR_TOP_OFFSET}
        classNames={{ root: 'anchor', item: 'anchor__link' }}
        onChange={handleAnchorAction}
        items={items}
      />
    </div>
  );
};
